<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='`审计${item.out === 1 ? "预算" : "结算"}`'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='650'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <div v-if="form.auditSettles.length > 0" class="my-3">
              <v-card v-for="(itm, idx) in form.auditSettles" :key="idx" outlined class="pa-4 my-3">
                <v-row>
                  <v-col cols="12" md='3'>
                    <v-select
                      :rules="required"
                      hide-details="auto"
                      outlined
                      :items="[{ text: '年审', value: 1 },{ text: '专审', value: 2 }]"
                      label="审计类型"
                      v-model="form.auditSettles[idx].settleType"
                      @change="findRang($event,idx)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md='3'>
                    <v-select
                      :rules="required"
                      hide-details="auto"
                      outlined
                      :items="[{ text: '只出报告', value: 1 },{ text: '审计底稿+出具报告', value: 2 }]"
                      label="服务类型"
                      v-model="form.auditSettles[idx].serviceType"
                      @change="findRang($event,idx)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md='3'>
                      <v-select
                        :rules="required"
                        hide-details="auto"
                        outlined
                        :items="channelItems"
                        label="结算渠道"
                        v-model="form.auditSettles[idx].channelId"
                        item-text='name'
                        item-value="id"
                        @change="findRang($event,idx)"
                      ></v-select>
                  </v-col>
                  <v-col cols="12" md="3" v-if="form.auditSettles[idx].settleType === 1">
                    <v-select
                      :items="yearItems"
                      label="结算年度"
                      v-model="form.auditSettles[idx].years"
                      hide-details='auto'
                      outlined
                      item-text='label'
                      :rules="required"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3" v-else>
                    <v-select
                      :items="specialTypeItems"
                      label="结算类型"
                      v-model="form.auditSettles[idx].specialTypeId"
                      hide-details='auto'
                      outlined
                      item-text='name'
                      item-value="id"
                      :rules="required"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md='4' v-if="item.out === 0">
                    <v-text-field label="资产总额" :rules="number" hide-details='auto' outlined v-model="form.auditSettles[idx].assets"></v-text-field>
                  </v-col>
                  <v-col cols="12" md='4' v-else>
                    <v-select
                      :rules="required"
                      hide-details="auto"
                      outlined
                      :items="form.auditSettles[idx].assetsRang"
                      label="资产区间"
                      item-text='assets'
                      item-value="id"
                      v-model="form.auditSettles[idx].setId"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md='7'>
                    <v-text-field label="备注信息" hide-details='auto' outlined v-model="form.auditSettles[idx].settleRemark"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="text-right">
                    <v-btn class="my-2 ml-n3" small depressed @click="moveAuditSettles(form.auditSettles, idx)" :disabled='form.auditSettles.length <= 1' fab color="primary">
                      <v-icon dark>mdi-minus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </div>
            <v-row class="mb-3">
              <v-col cols="12">
                <v-btn block  color="primary" @click="addAuditSettles()" outlined><v-icon>mdi-plus</v-icon>新增</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" rounded :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { selectData2 } from '@/utils/tool.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { save, findByCid } from '@/api/order/audit.js'

  export default {
    name: 'AuditSettle',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
          out: 0
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && !!value) || `必填且只能为数字`,
        ],
        channelItems: [],
        yearAssetsRang: [],
        specialTypeItems: [],
        yearItems: selectData2(),
        form: {
          orderId: '',
          out: '',
          auditSettles: []
        },
        auditSettle: {
          id: '',
          years: '',
          setId: '',
          assets: '',
          channelId: '',
          settleType: 1,
          serviceType: '',
          specialTypeId: '',
          settleRemark: '',
          assetsRang: []
        },
        defAuditSettle: {
          id: '',
          years: '',
          setId: '',
          assets: '',
          channelId: '',
          settleType: 1,
          serviceType: '',
          specialTypeId: '',
          settleRemark: '',
          assetsRang: []
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      moveAuditSettles (item, idx) {
        item.splice(idx, 1)
      },
      addAuditSettles () {
        this.auditSettle = JSON.parse(JSON.stringify(this.defAuditSettle))
        this.form.auditSettles.push(this.auditSettle)
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.orderId = this.item.data.id
          this.form.out = this.item.out
          if (this.isEdit) {
            this.form.auditSettles = []
            this.item.data.orderAuditSettles.forEach(obj => {
              if (obj.pay === 0 && obj.payPrice === 0) {
                obj.years = Number(obj.years)
                this.form.auditSettles.push(obj)
              }
            })
          } else {
            this.addAuditSettles()
          }
        } else {
          this.form.auditSettles = []
        }
      },
      findRang (ev, idx) {
        const channelId = this.form.auditSettles[idx].channelId || -1
        const settleType = this.form.auditSettles[idx].settleType || -1
        const serviceType = this.form.auditSettles[idx].serviceType || -1
        findByCid(channelId, settleType, serviceType).then(res => {
          if (res.status === 200) {
            this.form.auditSettles[idx].assetsRang = res.data
          }
          this.loading = false
        })
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.auditSettleChannelPid,
              this.$constants.specialTypePid
            ]
          }
          ).then(res => {
            if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.auditSettleChannelPid === result.id) {
                this_.channelItems = result.data
             } else if (this_.$constants.specialTypePid === result.id) {
                this_.specialTypeItems = result.data
             }
           })
          }
        })
      }
    },
    created() {
      this.getTypes()
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data.orderAuditSettles.length > 0
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
